import * as React from 'react';

import { ChatEmptyState as CdsLabsChatEmptyState } from '@coursera-web/cds-labs';
import type { SuggestionItem } from '@coursera-web/cds-labs';

export type { SuggestionItem };

type Props = {
  userName?: string;
  message?: string;
  suggestions?: SuggestionItem[];
};

const ChatEmptyState = ({ userName = '', message, suggestions = [] }: Props): React.ReactElement => {
  return <CdsLabsChatEmptyState userName={userName} message={message} suggestions={suggestions} />;
};

export default ChatEmptyState;
